<template>
    <div class="header">
        <div class="row">
            <div class="col-12 mr-0 p-0 pl-sm-1 pr-md-5 text-right">
                <div class="row">
                    <div class="col-1 offset-9 offset-sm-10 offset-md-11 pl-0">
                        <div class="logo-header-authentication"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    // import * as auth from '../../services/auth_service';

    export default {
        data() {
            return {
                logo_movigoo_src: 'img/group-10@3x.png',
            }
        }
    }
</script>
<style scoped>
    .logo-header-authentication {
        width: 87px;
        height: 21.5px;
        object-fit: contain;
        margin-top: 22px;
        margin-bottom: 22px;
        background: url('/img/group-10@3x.png');
        background-repeat: no-repeat;
        /* background-size: cover; */
    }

    .header {
        width: 95%;
        height: 60px;
        background-color: #ffffff;
    }
</style>